import { defineMessages } from 'react-intl';

export default defineMessages({
    linkText: {
        defaultMessage: '{formName} in {portalName}',
        description: 'Text used inside the recently used form link',
        id: 'cv.smart.portal.recent.request.types.link',
    },
});
